import RemoteSelect from "common/components/RemoteSelect/RemoteSelect";
import type { EventType } from "types";

const processOptions = (options: EventType[]) =>
  options.map(({ id, name, color }) => ({
    value: id,
    label: name,
    color,
  }));

function OptionLabel({
  color,
  label,
}: {
  color?: EventType["color"];
  label: string;
}) {
  return (
    <div className="flex items-center gap-2">
      {color ? (
        <div
          className="size-6 rounded-full shrink-0"
          style={{ backgroundColor: color }}
        />
      ) : (
        <div className="w-6 h-6 rounded bg-slate-200 shrink-0" />
      )}
      <span>{label}</span>
    </div>
  );
}

function EventTypeSelect(props: any) {
  return (
    <RemoteSelect
      url="event-types"
      processOptions={processOptions}
      formatOptionLabel={(option: any) => (
        <OptionLabel color={option.color} label={option.label} />
      )}
      sorts={["name:ASC"]}
      {...props}
    />
  );
}

export default EventTypeSelect;
